import { jsx as _jsx } from "react/jsx-runtime";
import { ModalDialog, Text, useLocalizeMessage } from 'libs.nucleus';
export const TimezoneChangeDetectedModal = ({ onCancel, onConfirm, onDontShowAgain, previousTimezone, currentTimezone, }) => {
    const translate = useLocalizeMessage();
    const confirmButton = {
        dataTestId: 'timezone-change-confirm-button',
        label: translate('Confirm'),
        onClick: onConfirm,
    };
    const cancelButton = {
        dataTestId: 'timezone-change-cancel-button',
        label: translate('Cancel'),
        onClick: onCancel,
    };
    const dontShowAgainButton = {
        dataTestId: 'timezone-change-dont-show-again-button',
        label: translate("Don't show again"),
        onClick: onDontShowAgain,
    };
    return (_jsx(ModalDialog, { title: translate('Timezone has been changed'), isOpen: true, closeDialog: onCancel, actionButtons: [confirmButton, dontShowAgainButton, cancelButton], width: 'lg', body: _jsx(Text, { className: 'text-text-primary', dataTestId: 'timezone-change-dialog', children: translate('It looks like your timezone has been changed from "{previousTimezone}". Would you like to update the current timezone to "{currentTimezone}"?', { previousTimezone, currentTimezone }) }) }));
};
